import { css } from "lit";

export const notificationModalStyles = css`
  :host {
    display: contents;
  }

  .notifications-header {
    color: var(--sds-color-text-default-default);

    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-heading-size);
    font-style: normal;
    font-weight: var(--sds-typography-weight-medium);
    line-height: 120%;
    letter-spacing: -0.4px;
  }

  .notifications-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }

  .notifications-list {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
    overflow-y: auto;
    flex: 1;
  }

  .notification-group {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-500);
  }

  .notification-group:not(:last-child)::after {
    content: "";
    display: block;
    height: 1px;
    background: rgb(44 44 44 / 0.5);
    margin-top: var(--sds-size-space-800);
  }

  .group-title {
    color: var(--sds-color-text-default-default);

    /* Heading Small */
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-heading-size-small);
    font-style: normal;
    font-weight: var(--sds-typography-weight-medium);
    line-height: 150%;
    margin: 0;
    padding-bottom: 16px;
  }

  .group-notifications {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--sds-size-space-600);
    flex: 1;
    color: var(--sds-color-text-default-secondary);
  }

  .empty-state ph-bell-simple {
    font-size: 48px;
    opacity: 0.5;
  }

  .empty-state p {
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-scale-03);
    font-weight: var(--sds-typography-weight-regular);
    margin: 0;
  }
`;
